export default __webpack_public_path__ + "right_control.png";